import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../config/consts";
import PQueue from "../utils/p-queue";

const queue = new PQueue({ concurrency: 1 });

const Context = React.createContext();

export class RequoteProvider extends React.Component {
  state = {
    isRequoteModalShown: false,
    result: undefined,
    versioningState: {},
    widgets: [],
    title: "",
    secondScreenWidgets: [],
    hasNextScreen: false,
    showRequote: () => {
      this.nextScreen();
    },
    closeRequote: () => {
      this.setState({
        ...this.state,
        isRequoteModalShown: false,
      });
    },
    updateWidget: this.updateWidget.bind(this),
    startVersioning: this.startVersioning.bind(this),
    onHandleContinue: this.onHandleContinue.bind(this),
    nextScreen: this.nextScreen.bind(this),
    showError: false,
    showedErrorMessage: () =>
      this.setState({
        showError: false,
      }),
    reload: false,
    reloaded: () =>
      this.setState({
        reload: false,
      }),
    hasChanges: false,
    newCards: [],
    addNewCards: (cardsToAdd) => {
      const absNew = cardsToAdd.filter((c) => !this.state.newCards.includes(c));
      if (absNew.length > 0) {
        const newArray = [...this.state.newCards, ...absNew];
        this.setState({
          newCards: newArray,
        });
      }
    },
  };

  render() {
    const {
      state,
      props: { children },
    } = this;

    return <Context.Provider value={state}>{children}</Context.Provider>;
  }

  updateWidget(widgetId, value, isSecondScreen) {
    queue.add(() =>
      axios({
        url: `${BACKEND_CONFIG.apiUrl}versioning/updateWidget`,
        method: "post",
        data: JSON.stringify({
          WidgetId: widgetId,
          ScreenTitle: this.state.ScreenTitle,
          Values: value,
          State: this.state.versioningState,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then((response) => {
        const {
          Widgets: widgets,
          State: versioningState,
          HasNextScreen: hasNextScreen,
          ScreenTitle: title,
        } = response.data;

        let newState = {
          ...this.state,
          versioningState,
          hasNextScreen,
          title,
          hasChanges: true,
        };

        isSecondScreen
          ? (newState.secondScreenWidgets = widgets)
          : (newState.widgets = widgets);

        this.setState(newState);
      })
    );
  }

  onHandleContinue() {
    queue.add(() =>
      axios({
        url: `${BACKEND_CONFIG.apiUrl}versioning/submitchanges`,
        method: "post",
        data: JSON.stringify({
          State: this.state.versioningState,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const {
            Widgets: widgets,
            State: versioningState,
            HasNextScreen: hasNextScreen,
            Result: result,
          } = response.data;
          this.setState({
            ...this.state,
            widgets,
            versioningState,
            hasNextScreen,
            result,
            reload: true,
          });
        })
        .catch(() => {
          this.setState({ showError: true });
        })
    );
  }

  startVersioning(selectedPolicyQuoteId) {
    queue.add(() =>
      axios({
        url:
          BACKEND_CONFIG.apiUrl + `versioning/start/${selectedPolicyQuoteId}`,
        method: "get",
      }).then((response) => {
        const {
          Widgets: widgets,
          State: versioningState,
          HasNextScreen: hasNextScreen,
        } = response.data;
        this.setState({
          widgets: widgets,
          versioningState: versioningState,
          quoteVersioningAction: "Requote",
          hasNextScreen: hasNextScreen,
          result: {},
          hasChanges: false,
        });
      })
    );
  }

  nextScreen() {
    queue.add(() =>
      axios({
        url: `${BACKEND_CONFIG.apiUrl}versioning/nextscreen`,
        method: "post",
        data: JSON.stringify({ State: this.state.versioningState }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const {
            Widgets: secondScreenWidgets,
            State: versioningState,
            HasNextScreen: hasNextScreen,
            ScreenTitle: title,
          } = response.data;
          this.setState({
            ...this.state,
            secondScreenWidgets,
            versioningState,
            hasNextScreen: true,
            title: "Requote",
            isRequoteModalShown: true,
            result: {},
            quoteVersioningAction: "Requote",
          });
        })
        .catch((error) => {
          console.log(error);
        })
    );
  }

  previousscreen() {
    queue.add(() =>
      axios({
        url: `${BACKEND_CONFIG.apiUrl}versioning/previousscreen`,
        method: "post",
        data: JSON.stringify({ State: this.state.versioningState }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const {
            Widgets: widgets,
            State: versioningState,
            HasNextScreen: hasNextScreen,
          } = response.data;
          this.setState({
            ...this.state,
            widgets,
            versioningState,
            hasNextScreen,
            title: "",
            secondScreenWidgets: [],
            isRequoteModalShown: false,
          });
        })
        .catch((error) => {
          console.log(error);
        })
    );
  }
}

export const RequoteConsumer = Context.Consumer;
